
<template>
    <div class="bg-gray-200 h-screen">
        
        <div v-if="modal_consulta_mostrado == false" class="bg-gray-200 pt-4 pb-32">
            <h1 class="text-azuloscuro text-xl font-semibold p-4">
                Preguntas frecuentes
            </h1>
            
            <div v-for="(faq,idx) in faqs" v-bind:key=idx class="px-4 cursor-pointer"
            @click="mostrarPreguntaFrecuente(idx)">
                <div class="flex items-center justify-between bg-white rounded-lg p-4 border border-gray-300">
                    <span class="ball filled"></span>
                    <div class="text-azuloscuro text-sm ml-4 w-full">{{faq.question}}</div>
                </div>
            </div>

            <div v-if="consulta_enviada == true" class="mt-5">
                <h1 class="text-azuloscuro text-xl text-center font-semibold p-4 mb-4 leading-6">
                    Muchas gracias. Recibirás tu respuesta vía email lo más pronto posible.
                </h1>

                <div class="p-4 mb-4">
                    <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full" 
                    @click="enviarOtraConsulta" type="button">
                        Enviar nueva consulta
                    </button>
                </div>
            </div>

            <div v-if="consulta_enviada == false" class="mt-2">
                <h1 class="text-azuloscuro text-xl font-semibold p-4">
                    ¿No has encontrado la respuesta? ¡Escríbenos!
                </h1>
                
                <div class="mb-4 px-4">
                    <textarea class="bg-white rounded-lg p-4 border border-gray-300 w-full" 
                    rows="5" v-model="consulta">
                                        
                    </textarea>
                </div>

                <div class="p-4 mb-4">
                    <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full" 
                    @click="enviarConsulta" type="button">
                        Enviar consulta
                    </button>
                </div>
            </div>

            <Menu current="suport"/>
        </div>

        <div v-if="modal_consulta_mostrado == true" 
        class="h-screen w-full flex flex-col justify-center z-50 bg-gray-200 overflow-y-scroll">
            <div class="mb-4 px-4 cursor-pointer max-h-screen">
                <div class="flex flex-col justify-between bg-white rounded-lg p-4 border border-gray-300  mt-10 mb-10">

                    <div class="text-right">
                        <button class="px-3 pt-1 pb-2 self-right shadow rounded-lg leading-6 hover:bg-gray-500 hover:text-white"
                        @click="cerrarPreguntaFrecuente">
                            x
                        </button>
                    </div>

                    <h1 class="text-azuloscuro text-xl font-semibold p-4 mb-1">
                        {{faqs[faq_idx].question}}
                    </h1>

                    <div class="text-gray-600 text-sm ml-4 leading-5 mb-5">
                        {{faqs[faq_idx].answer}}
                    </div>

                    <div class="p-4 mb-4">
                        <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                        @click="cerrarPreguntaFrecuente" type="button">
                            Entendido
                        </button>
                    </div>

                </div>


            </div>
        </div>
    </div>


</template>

<script>
    import Vue from 'vue'
    import Utilities from '@/plugins/Utilities.js'
    import faqs from '@/plugins/api/faqs/faqs'
    import Zondicon from 'vue-zondicons'
    import Menu from '@/components/Menu'
    import users from "@/plugins/api/users/users.js";
    import setTitle from "../plugins/title";

    const Support = {
        name: 'Support',
        layout: 'layout',
        components: {
            Menu,
            Zondicon
        },
        data: function(){
            return {
                user: {},
                consulta: '',
                modal_consulta_mostrado: false,
                consulta_enviada: false,
                faq_idx: null,
                faqs: {}
            }
        },
        beforeMount: function(){
            if(!Utilities.isLogged()){
                this.$router.push({ name:'login' })
            }
            this.loadUser()
            this.loadFaqs()
        },
        methods: {
            async loadUser() {
                try {
                    const response = await users.getSelfUser();
                    this.user = response.data;
                } catch (e) {
                    console.error(e);
                }
            },
            async enviarConsulta(){
                if(this.consulta !== ''){
                    var data = {
                        user: this.user['@id'],
                        content: this.consulta
                    };
                    await faqs.sendTicket(data).then(response => {
                        this.consulta = '';
                        this.consulta_enviada = true;
                    });
                }
            },
            enviarOtraConsulta: function(){
                this.consulta = ''
                this.consulta_enviada = false
            },

            mostrarPreguntaFrecuente: function(idx){
                this.modal_consulta_mostrado = true
                this.faq_idx = idx
            },

            cerrarPreguntaFrecuente: function(){
                this.modal_consulta_mostrado = false
            },
            async loadFaqs () {
                try {
                    const response = await faqs.getFaqs()
                    this.faqs = response.data['hydra:member']
                } catch (e) {
                    console.error(e)
                }
            }
        },
        created () {
            setTitle('Soporte')
        }
    }

    export default Support;
</script>

<style>
    .ball {
        display: inline-block;
        background: gray;
        border-radius: 50%;
        font-size: 0px;
        width: 10px;
        height: 10px;
        margin: 0 6px;
        background: #E9ECFF;
        vertical-align: middle;
    }

    .filled {
        background: #170E47;
    }
</style>
